// extracted by mini-css-extract-plugin
module.exports = {"container":"L3-5estp-PlbclsyEoS9+w==","avatar":"tBKE9itc+52kcJCvtDvSTw=="};